import { takeEvery, take, put } from 'redux-saga/effects';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { consts as postsList } from './postsList';
import { consts as newPostForm } from './newPostForm';
import { consts as postDetails } from './postDetails';
import { consts as urlPreview } from '../common/urlPreview';

export const consts = createReqConsts('communities', 'editPost');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'posts',
    {
      type: 'payload',
      selector: ['postId'],
    },
  ],
});

export default createReqReducer(consts);

function* editedPostWorker(action) {
  yield put({
    type: newPostForm.CLEAR_FORM,
  });
  yield put({
    type: urlPreview.CLEAR,
  });
  yield put({
    type: postsList.EDIT_POST,
    payload: action.payload,
  });
  yield put({
    type: postDetails.EDIT,
    payload: action.payload,
  });
}

export function* editedPostSaga() {
  yield takeEvery(consts.SUCCEED, editedPostWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/editPost.js